import React, { Component } from "react";
import { color, dividedRange } from "utils";

const CustomDiscreteColorLegend = ({
  orientation,
  symbolSize,
  items,
  onItemMouseEnter,
  onItemMouseLeave,
}) => (
  <div className={"rv-discrete-color-legend" + (orientation ? ` ${orientation}` : "")}>
    {items.map((v, i) => (
      <div
        key={i}
        className={
          "rv-discrete-color-legend-item" +
          (orientation ? ` ${orientation}` : "") +
          (v.disabled ? " disabled" : "")
        }
        onMouseEnter={() => onItemMouseEnter(v)}
        onMouseLeave={() => onItemMouseLeave(v)}
      >
        <svg
          className="rv-discrete-color-legend-item__color"
          width={symbolSize}
          height={symbolSize}
        >
          <rect
            width={symbolSize}
            height={symbolSize}
            fill={color(i, v.title)}
            style={{ opacity: v.disabled ? 0.5 : 1 }}
          />
        </svg>
        <span className="rv-discrete-color-legend-item__title">{v.title}</span>
      </div>
    ))}
  </div>
);

// Composant graphique pour afficher un Square grid horizontal.
// Plein de petits carrés pour représenter chaque unité.
// Inspiration: https://bl.ocks.org/mbostock/1009139
class HorizontalSquareGrid extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      hint: false,
      cellSize: this.props.cellSize || 6,
      cellMargin: this.props.cellMargin || 1,
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.refreshes === prevState.refreshes || !nextProps.data) return null;

    return {
      data: nextProps.data,
      refreshes: nextProps.refreshes,
    };
  }

  renderCells(values, groups, groupWidth) {
    const { hint, cellMargin, cellSize } = this.state;
    return groups.map((group, i) => (
      <div
        key={i}
        style={{
          width: groupWidth,
        }}
      >
        {group.map((valueIndex, j) => {
          const label = values[valueIndex].label;
          return (
            <div
              key={i * 100 + j}
              style={{
                margin: cellMargin,
                width: cellSize,
                height: cellSize,
                backgroundColor: color(valueIndex, label),
                opacity: !hint || hint.label === label ? 1 : 0.5,
              }}
            ></div>
          );
        })}
      </div>
    ));
  }

  render() {
    const { hint } = this.state;
    const data = [...this.state.data];

    // Logique pour les effets du hover.
    (data || []).map((d) =>
      d.values.map((v) => {
        if (hint) {
          v.className = v.label === hint.label ? "hovered" : "not-hovered";
        } else {
          v.className = "";
        }
      }),
    );

    return (
      <div className="horiz-square-grid-wrap">
        <CustomDiscreteColorLegend
          orientation={this.props.legendOrientation}
          symbolSize={this.state.cellSize}
          items={((data.length && data[0].values) || []).map((v, i) => ({
            title: v.label,
            color: v.color,
            disabled: v.className === "not-hovered",
            hint: { ...v },
          }))}
          onItemMouseEnter={(item) => this.setState({ hint: item.hint })}
          onItemMouseLeave={() => this.setState({ hint: false })}
        />
        <ul className="horiz-square-grid">
          {data.map((d, i) => {
            const repartition = d.values.map((v) => v.value);
            const groups = dividedRange(repartition, 100); // Regroupements en carrés de 100 (10x10)
            return (
              <li key={i}>
                <p>
                  {d.group}{" "}
                  <small>
                    {d.values
                      .map((v, i) => (
                        <span
                          key={i}
                          style={{
                            opacity: !hint || v.label === hint.label ? 1 : 0.5,
                            color: color(i, v.label),
                          }}
                        >
                          {v.value}
                        </span>
                      ))
                      .reduce((prev, curr, j, arr) => [
                        prev,
                        <span key={arr.length + j} style={{ opacity: hint ? 0.5 : 1 }}>
                          {" "}
                          •{" "}
                        </span>,
                        curr,
                      ])}
                  </small>
                </p>
                <div>
                  {this.renderCells(
                    d.values,
                    groups,
                    10 * (this.state.cellSize + 2 * this.state.cellMargin),
                  )}
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    );
  }
}

export default HorizontalSquareGrid;
